import { Fragment } from 'react';
import { css, jsx } from '@emotion/react';
import { DateTime } from '@zapier/date';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import { isSameDay } from './utils.es.js';

const Styles = {
  root: css`
    display: block;
    overflow: hidden;
    white-space: nowrap;
  `,
  wrapper: css`
    display: flex;
    max-width: 100%;
    overflow: hidden;
  `
};
function getRangeText(value) {
  const isSameDate = isSameDay(value.from, value.to);
  const from = value.from ? (
    // We have to ignore profile timezone here and just stick to the browser
    // since there could be a huge mismatch which would result in the days showing
    // different values 😭
    jsx(DateTime, { date: value.from, format: "MM/DD/YY", ignoreProfileTimezone: true })
  ) : null;
  const to = !isSameDate && value.to ? jsx(DateTime, { date: value.to, format: "MM/DD/YY", ignoreProfileTimezone: true }) : null;
  return jsx(
    Fragment,
    null,
    from,
    Boolean(from) && Boolean(to) && " – ",
    to
  );
}
const DateRangePickerValue = ({ options, value }) => {
  const selectedOption = options.find((option) => isSameDay(option.value.from, value.from) && isSameDay(option.value.to, value.to));
  const rangeText = getRangeText(value);
  return jsx(
    "div",
    { css: Styles.wrapper, "data-zds": true },
    jsx(TooltipWrapper, { content: selectedOption ? rangeText : null }, ({ childProps }) => jsx("span", { "aria-describedby": childProps["aria-describedby"], css: Styles.root, "data-zds": true }, selectedOption ? selectedOption.text : rangeText))
  );
};

export { DateRangePickerValue };
//# sourceMappingURL=DateRangePickerValue.es.js.map
